/**
 * Toast Notification Utility
 * Centralized toast notification helper using react-toastify
 */

import { toast } from 'react-toastify'

/**
 * Show success toast
 * @param {string} message - Success message
 * @param {object} options - Additional toast options
 */
export const showSuccess = (message, options = {}) => {
  toast.success(message, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    ...options,
  })
}

/**
 * Show error toast
 * @param {string} message - Error message
 * @param {object} options - Additional toast options
 */
export const showError = (message, options = {}) => {
  toast.error(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    ...options,
  })
}

/**
 * Show warning toast
 * @param {string} message - Warning message
 * @param {object} options - Additional toast options
 */
export const showWarning = (message, options = {}) => {
  toast.warning(message, {
    position: 'top-right',
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    ...options,
  })
}

/**
 * Show info toast
 * @param {string} message - Info message
 * @param {object} options - Additional toast options
 */
export const showInfo = (message, options = {}) => {
  toast.info(message, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    ...options,
  })
}

/**
 * Show promise toast (for async operations)
 * @param {Promise} promise - Promise to track
 * @param {object} messages - Messages for pending, success, and error states
 */
export const showPromise = (promise, messages) => {
  return toast.promise(promise, messages, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  })
}
